var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"vs-component vs-switch",class:[
           `vs-switch`,
           {
           'vs-switch-active':_vm.value
           }
           ]},'button',_vm.$attrs,false),[_c('input',_vm._g(_vm._b({ref:"inputCheckbox",staticClass:"input-switch vs-switch--input",attrs:{"disabled":_vm.$attrs.disabled,"type":"checkbox"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.listeners)),_c('span',{ref:"on",staticClass:"text-on text-switch vs-switch--text",class:{'active-text':_vm.value }},[_vm._t("default")],2),_c('span',{ref:"off",staticClass:"text-off text-switch vs-switch--text",class:{'active-text':!_vm.value}},[_vm._t("default")],2),_c('span',{staticClass:"vs-circle-switch vs-switch--circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }